export const AUTHORIZATION_NEEDED = 'AUTHORIZATION_NEEDED';
export const CANT_FETCH_GRANT = 'CANT_FETCH_GRANT';



// WEBPACK FOOTER //
// ../../src/user/errorCodes.js